var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChainId } from '@shared/utils/config/networks';
import { useQuery } from '@tanstack/react-query';
var fetchTrendingTokens = function (networkFilter, resolution, limit) { return __awaiter(void 0, void 0, void 0, function () {
    var adjustedRes, networks, url, response, payload, data, formatted;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                adjustedRes = function () {
                    switch (resolution) {
                        case '24':
                            return '1D';
                        case '12':
                            return '720';
                        case '4':
                            return '240';
                        case '1':
                            return '60';
                        default:
                            return '1D';
                    }
                };
                networks = networkFilter.join(',');
                url = "/api/explore/trendingToken?limit=".concat(limit, "&networkFilter=").concat(networks, "&resolution=").concat(adjustedRes());
                return [4 /*yield*/, fetch(url)];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return [4 /*yield*/, response.json()];
            case 2:
                payload = _a.sent();
                data = payload === null || payload === void 0 ? void 0 : payload.data;
                formatted = data.data.listTopTokens.map(function (x) {
                    return __assign(__assign({}, x), { priceUSD: x.price, change24: x.priceChange24, change1: x.priceChange1, change4: x.priceChange4, change12: x.priceChange12, logo: x.imageSmallUrl, token: __assign(__assign({}, x), { priceUSD: x.price, change24: x.priceChange24, change1: x.priceChange1, change4: x.priceChange4, change12: x.priceChange12, logo: x.imageSmallUrl }) });
                });
                formatted
                    .sort(function (token1, token2) { return parseFloat(token2 === null || token2 === void 0 ? void 0 : token2.marketCap) - parseFloat(token1 === null || token1 === void 0 ? void 0 : token1.marketCap); })
                    .sort(function (token1, token2) {
                    if ((token1 === null || token1 === void 0 ? void 0 : token1.networkId) === ChainId.SOLANA ||
                        (token1 === null || token1 === void 0 ? void 0 : token1.networkId) === ChainId.SOLANA_DLN ||
                        (token1 === null || token1 === void 0 ? void 0 : token1.networkId) === ChainId.BASE) {
                        return -1;
                    }
                    else {
                        return 1;
                    }
                });
                //put token with networkid 1 at end
                return [2 /*return*/, formatted];
        }
    });
}); };
export default function useTrendingTokens(_a) {
    var networkFilter = _a.networkFilter, _b = _a.resolution, resolution = _b === void 0 ? '24' : _b, _c = _a.limit, limit = _c === void 0 ? 100 : _c;
    var _d = useQuery({
        queryKey: ['trendingTokens', networkFilter, resolution, limit],
        queryFn: function () { return fetchTrendingTokens(networkFilter, resolution, limit); },
        staleTime: 1000 * 30,
    }), tokens = _d.data, isLoading = _d.isLoading, isFetching = _d.isFetching, error = _d.error;
    return { tokens: tokens, isLoading: isLoading, error: error };
}
